import { useAppSelector } from "~/hooks";
import { FlowCards } from "../components/FlowCards";
import { SectionErrorBoundary } from "../components/SectionErrorBoundary";
import { SectionWrapper } from "../components/SectionWrapper";
import type { SectionStatus } from "../hooks/usePageViewData";
import styles from "./WorkflowSection.module.scss";

type WorkflowSectionProps = {
  number: number;
  status: SectionStatus;
};

export const WorkflowSection = ({ number, status }: WorkflowSectionProps) => {
  const { data, firstKey } = useAppSelector((s) => s.systemProposalReducer);
  const overview = data[firstKey]?.システム概要;

  const renderContent = () => {
    if (!overview) {
      return (
        <div className={styles["fallback"]}>
          コンテンツを表示できません。詳細ページで確認してください →
        </div>
      );
    }

    return (
      <div className={styles["content"]}>
        <section className={styles["subsection"]}>
          <h3 className={styles["subsectionTitle"]}>業務フロー</h3>
          <FlowCards items={overview.業務フロー} />
          <p className={styles["hint"]}>※ 詳細版の業務フロー図は別途生成が可能です</p>
        </section>
      </div>
    );
  };

  if (status === "generating" || status === "ready" || status === "locked") {
    return null;
  }

  return (
    <SectionWrapper number={number} title="業務フロー" status={status} showStatus={false}>
      <SectionErrorBoundary sectionName="業務フロー">{renderContent()}</SectionErrorBoundary>
    </SectionWrapper>
  );
};
